"use strict";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.directive("obsSdisMapTooltip", function (obsUtils) {
    return {
        restrict: "E",
        require: "^obsSdisManager",
        scope: true,
        replace: true,
        template: `
        <div class="leaflet-control control obs-map-tooltip">
            <div class="hovered-name-sdis">{{hoverName}} </div>
            <div class="hovered-categorie-sdis"><span>Catégorie</span> <span class="align-c certain-true-circle">{{hoverCategorie}}</span></div>
            <div class="hovered-value">
                {{referenceLabel}}: {{hoverValue}}
            </div>
        </div>`,
        link: function ($scope, $el, $attrs, managerCtrl) {
            $scope.$watch(() => managerCtrl.getHoveredCommune(), (hoveredCommune) => {
                if (hoveredCommune == null) {
                    $scope.hoverName = null;
                    $scope.hoverValue = null;
                    $scope.hoverCategorie = null;
                } else {
                    $scope.hoverName = hoveredCommune.nom + " (" + hoveredCommune.departement + ") ";
                    $scope.hoverValue = obsUtils.formatValue($scope.communeParams, hoveredCommune.value);
                    $scope.hoverCategorie = hoveredCommune.categorie;
                }
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/sdis/obsSdisMapTooltip.js